import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_LOCAL_API_REQUESTS } from './constants';

export const getRenologDevices = async (projectId, doSync) => {
  const apiPath = doSync
    ? `projects/${projectId}/renolog/devices?doSync=true`
    : `projects/${projectId}/renolog/devices`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: RENOLOG_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
